<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { TabsList, type TabsListProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = withDefaults(
  defineProps<
    TabsListProps & {
      class?: HTMLAttributes['class'];
      variant?: 'default' | 'minimal';
    }
  >(),
  {
    variant: 'default',
  }
);

const delegatedProps = reactiveOmit(props, 'class', 'variant');
</script>

<template>
  <TabsList
    data-slot="tabs-list"
    v-bind="delegatedProps"
    :class="
      cn(
        props.variant === 'minimal'
          ? 'text-muted-foreground inline-flex h-auto w-fit items-center justify-center gap-1 rounded-full bg-transparent p-0'
          : 'bg-muted text-muted-foreground inline-flex h-9 w-fit items-center justify-center rounded-lg p-[3px]',
        props.class
      )
    "
  >
    <slot />
  </TabsList>
</template>
